import {
    CONFIRM_POST_SESSION_STEP_ID,
    type ConfirmPostSessionStepResume,
} from '@fruitful/types';

import { useResumeWorkflow } from '../../llm-service/hooks/useResumeWorkflow';
import { WorkflowId } from '../../llm-service/types/workflowIds';

export const useConfirmPostSessionWorkflowOutput = (
    runId: string,
    resourceId?: string,
) => {
    const { mutateAsync: resumeWorkflow, ...rest } = useResumeWorkflow();

    const confirm = async (resumeData: ConfirmPostSessionStepResume) => {
        await resumeWorkflow({
            workflowId: WorkflowId.POST_SESSION_WORKFLOW_ID,
            runId,
            resourceId,
            step: CONFIRM_POST_SESSION_STEP_ID,
            resumeData,
        });
    };

    return {
        confirm,
        ...rest,
    };
};
